import { Avatar, Box, IconButton, Tooltip, Typography, alpha, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import { useGetIdentity, useLogout } from 'react-admin';
import { brandGradients } from '../../../themes/brandTokens';

const initials = (name?: string) =>
  String(name || '')
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part.charAt(0).toUpperCase())
    .join('');

// The signed-in user at the foot of the sidebar: initials, name, account, and logout.
function SidebarFooter() {
  const { t }: { t: any } = useTranslation();
  const theme = useTheme();
  const logout = useLogout();
  const { identity } = useGetIdentity();
  const name = identity?.fullName || identity?.name || '';
  const detail = identity?.account || identity?.email || '';

  return (
    <Box
      display="flex"
      alignItems="center"
      gap={1.5}
      sx={{ px: 2, py: 1.5, borderTop: `1px solid ${theme.colors.alpha.trueWhite[10]}` }}
    >
      <Box
        sx={{
          p: '2px',
          borderRadius: '50%',
          background: brandGradients.accentBar,
          flexShrink: 0
        }}
      >
        <Avatar
          sx={{
            width: 34,
            height: 34,
            fontSize: 13,
            fontWeight: 600,
            color: theme.colors.alpha.trueWhite[100],
            background: theme.sidebar.background,
            border: `2px solid ${theme.sidebar.background}`
          }}
        >
          {initials(name)}
        </Avatar>
      </Box>
      <Box sx={{ minWidth: 0, flex: 1 }}>
        <Typography
          noWrap
          sx={{ fontSize: 14, fontWeight: 600, color: theme.colors.alpha.trueWhite[100], lineHeight: 1.3 }}
        >
          {name}
        </Typography>
        {detail && (
          <Typography noWrap sx={{ fontSize: 12, color: theme.colors.alpha.trueWhite[50], lineHeight: 1.3 }}>
            {detail}
          </Typography>
        )}
      </Box>
      <Tooltip placement="top" arrow title={t('Logout')}>
        <IconButton
          aria-label={t('Logout')}
          onClick={() => logout()}
          sx={{
            color: theme.colors.alpha.trueWhite[70],
            '&:hover': {
              background: alpha(theme.colors.alpha.trueWhite[100], 0.08),
              color: theme.colors.alpha.trueWhite[100]
            },
            '&.Mui-focusVisible': { outlineColor: theme.colors.alpha.trueWhite[100] }
          }}
        >
          <LogoutRoundedIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </Box>
  );
}

export default SidebarFooter;
